import { httpsUrl } from '@/utils/journeyMedia';

export const PARTY_ANIMALS_COMPLETION_IMAGE = '/mascots/party-animals-group.webp';

/** Authored artwork wins. Only official Journeys inherit Journal Party artwork. */
export function journeyCompletionArtwork(journey: {
  experience_config?: unknown;
  creation_source?: string | null;
}): string | null {
  const config = journey.experience_config;
  if (!config || typeof config !== 'object' || Array.isArray(config)
    || !('version' in config) || config.version !== 'course_v1') return null;
  const custom = 'completion_image_url' in config && typeof config.completion_image_url === 'string'
    ? httpsUrl(config.completion_image_url) : null;
  return custom ?? (journey.creation_source === 'admin' ? PARTY_ANIMALS_COMPLETION_IMAGE : null);
}
